import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import SEO from '../common/SEO/SEO';
import {
  NotFoundPageWrapper,
  NotFoundCard,
  NotFoundHeaderBand,
  NotFoundCode,
  NotFoundTitle,
  NotFoundMessage,
  NotFoundActions,
  NotFoundPrimaryButton,
  NotFoundSecondaryButton,
} from './NotFoundPage.styled';

function NotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  const handleGoBack = () => {
    if (location.key !== 'default') {
      navigate(-1);
      return;
    }
    navigate('/', { replace: true });
  };

  return (
    <NotFoundPageWrapper>
      <SEO
        title="Page not found"
        description="The page you requested could not be found on NKY Connect."
        path={location.pathname}
        noindex
      />
      <NotFoundCard>
        <NotFoundHeaderBand>
          <NotFoundCode>404</NotFoundCode>
          <NotFoundTitle>Page not found</NotFoundTitle>
        </NotFoundHeaderBand>
        <NotFoundMessage>
          We couldn&apos;t find that page. It may have moved, or the link might be
          incorrect.
        </NotFoundMessage>
        <NotFoundActions>
          <NotFoundSecondaryButton
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={handleGoBack}
          >
            Go back
          </NotFoundSecondaryButton>
          <NotFoundPrimaryButton
            variant="contained"
            disableElevation
            startIcon={<HomeOutlinedIcon />}
            onClick={handleGoHome}
          >
            Return home
          </NotFoundPrimaryButton>
        </NotFoundActions>
      </NotFoundCard>
    </NotFoundPageWrapper>
  );
}

export default NotFoundPage;
